import React, { useMemo } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

interface Props {
  regions: string[]
}

export default function RegionPicklist({
  name = 'region',
  label = 'Region',
  compact = false,
  regions = [],
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const options = useMemo(() => {
    return regions.map((region) => ({
      label: region,
      value: region,
    }))
  }, [regions])

  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
